function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M118.453,48.854c-0.073-0.174-0.165-0.336-0.266-0.49c-0.012-0.018-0.024-0.034-0.037-0.051 c-0.096-0.141-0.202-0.271-0.318-0.392c-0.016-0.015-0.025-0.032-0.039-0.047l-12.997-12.996c-1.171-1.172-3.071-1.172-4.243,0 s-1.171,3.071,0,4.242l7.885,7.883H81.105V3c0-1.658-1.344-3-3-3H3C1.342,0,0,1.342,0,3v94c0,1.657,1.342,3,3,3h75.105 c1.656,0,3-1.343,3-3V53.004h27.332l-7.875,7.875c-1.17,1.171-1.17,3.07,0,4.242c0.586,0.586,1.354,0.879,2.123,0.879 c0.768,0,1.535-0.293,2.121-0.879l12.996-12.996C118.661,51.268,118.918,49.978,118.453,48.854 M75.105,94H6V6h69.105v41.004H40.552 c-1.657,0-3,1.343-3,3s1.343,3,3,3h34.553V94z"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 120,
    height: 101,
    viewBox: "-0.727 -0.752 120 101",
    enableBackground: "new -0.727 -0.752 120 101",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.4db65776.svg";
export { ForwardRef as ReactComponent };